import { render, staticRenderFns } from "./sky-radio.vue?vue&type=template&id=1d19b820&scoped=true"
import script from "./sky-radio.vue?vue&type=script&lang=js"
export * from "./sky-radio.vue?vue&type=script&lang=js"
import style0 from "./sky-radio.vue?vue&type=style&index=0&id=1d19b820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d19b820",
  null
  
)

export default component.exports